

export default async function CommonGetMethod(url){
   const result = await fetch(url,{
        method:"GET",
        headers:{
            "Content-Type":"Application/json",
            "Accept":"Application/json"
        }
    }).then((res)=>{return res.json()})

    return result
}